export default __webpack_public_path__ + "static/media/books-1024w.62d0f9e3.png";